/* eslint-disable no-undef */
import api from "./ApiService";

const getAttachments = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/entities/${data}/attachments`)
    .then((response: any) => {
      return response;
    });
};

const getMortgageClasAttachments = (data?: any) => {
  return api
    .get(
      process.env.REACT_APP_API_BASE_URL +
        `/entities/${data}/mortgageclas-attachments`
    )
    .then((response: any) => {
      return response;
    });
};

const getMortgageClasRequiredDocuments = (data?: any) => {
  return api
    .get(
      process.env.REACT_APP_API_BASE_URL +
        `/entities/${data}/mortgageclas-required-documents`
    )
    .then((response: any) => {
      return response;
    });
};

const getProcessLogs = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/entities/${data}/process-logs`)
    .then((response: any) => {
      return response;
    });
};

const reProcess = (id?: any) => {
  return api
    .put(process.env.REACT_APP_API_BASE_URL + `/entities/${id}/re-process`)
    .then((response: any) => {
      return response;
    });
};

const reProcessMortgageClas = (id?: any) => {
  return api
    .put(
      process.env.REACT_APP_API_BASE_URL +
        `/entities/${id}/re-process-mortgageclas`
    )
    .then((response: any) => {
      return response;
    });
};

const overrideMissingDocument = (id?: any) => {
  return api
    .put(
      process.env.REACT_APP_API_BASE_URL +
        `/entities/${id}/override-missing-document`
    )
    .then((response: any) => {
      return response;
    });
};

const retryCurrentStep = (id?: any) => {
  return api
    .put(
      process.env.REACT_APP_API_BASE_URL + `/entities/${id}/retry-current-step`
    )
    .then((response: any) => {
      return response;
    });
};

const exportToExcel = (payload?: any) => {
  return api
    .post(
      process.env.REACT_APP_API_BASE_URL + `/entities/export-to-excel`,
      payload,
      {
        responseType: "blob",
      }
    )
    .then((response: any) => {
      return response;
    });
};

const EntityServices = {
  getAttachments,
  getMortgageClasAttachments,
  getMortgageClasRequiredDocuments,
  getProcessLogs,
  reProcess,
  reProcessMortgageClas,
  overrideMissingDocument,
  retryCurrentStep,
  exportToExcel,
};
export default EntityServices;
